export const GET_REGISTERED_USER_DISCOUNTS = 'GET_REGISTERED_USER_DISCOUNTS';